<template>
    <svg
        width="24"
        height="24"
        viewBox="2.5 2.5 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.25 7.5C13.0074 7.5 12 8.50736 12 9.75C12 10.9926 13.0074 12 14.25 12C15.4926 12 16.5 10.9926 16.5 9.75C16.5 8.50736 15.4926 7.5 14.25 7.5ZM13.5 9.75C13.5 9.33579 13.8358 9 14.25 9C14.6642 9 15 9.33579 15 9.75C15 10.1642 14.6642 10.5 14.25 10.5C13.8358 10.5 13.5 10.1642 13.5 9.75Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.5 6C4.5 5.17157 5.17157 4.5 6 4.5H18C18.8284 4.5 19.5 5.17157 19.5 6V18C19.5 18.8284 18.8284 19.5 18 19.5H6C5.17157 19.5 4.5 18.8284 4.5 18V6ZM18 6V14.6893L16.8107 13.5C16.2249 12.9142 15.2751 12.9142 14.6893 13.5L13.5 14.6893L10.0607 11.25C9.47487 10.6642 8.52513 10.6642 7.93934 11.25L6 13.1893V6L18 6ZM6 18V15.3107L9 12.3107L12.4393 15.75C13.0251 16.3358 13.9749 16.3358 14.5607 15.75L15.75 14.5607L18 16.8107V18H6Z"
            fill="currentColor"
        />
    </svg>
</template>
